export const ALPHA_NUMERIC_REGEX = /[a-zA-Z0-9]/;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const ALPHA_NUMERIC_REGEX_NO_SPACE = /^[a-zA-Z0-9]*$/;

export const ANCHOR_TAG_REGEX = /(<a\s+href=["'][^"']+["'][^>]*>[^<]*<\/a>)/gi;

export const ANCHOR_TAG_REGEX_WITH_TEXT =
  /<a\s+href=["']([^"']+)["'][^>]*>([^<]*)<\/a>/i;

export const NON_ANCHOR_TEXT_REGEX = /<\/?[a-zA-Z0-9\s="':\-_.;,#[\]()/]*>/g;

export const NAME_REGEX = /^[a-z0-9 ,.'-]+$/i;

// US Postal Code: 12345 or 12345-6789 (from bolt)
export const US_POSTAL_CODE = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

// Canadian Postal Code: A1A 1A1 (with space) (from bolt)
export const CA_POSTAL_CODE = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
